export function updateSliderAccessibility(slider, selectors) {
    const sliderRoot = document.querySelector(selectors.hpNewsletterSlider);
    if (!sliderRoot)
        return;
    const slides = Array.from(sliderRoot.querySelectorAll(selectors.hpNewsletterSlide));
    const leftArrow = sliderRoot.querySelector(selectors.rightHpNewsletterArrowLeft);
    const rightArrow = sliderRoot.querySelector(selectors.rightHpNewsletterArrowRight);
    const isElementVisible = (el) => {
        while (el) {
            const style = getComputedStyle(el);
            if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0")
                return false;
            el = el.parentElement;
        }
        return true;
    };
    const setArrowState = (arrow, disabled) => {
        if (!arrow)
            return;
        arrow.dataset.disabled = disabled ? "true" : "false";
        arrow.style.pointerEvents = disabled ? "none" : "auto";
        arrow.setAttribute("tabindex", disabled ? "-1" : "0");
        const icon = arrow.querySelector("svg *");
        if (icon)
            icon.setAttribute("fill", disabled ? "#D0D0D0" : "#000");
    };
    const updateArrowState = () => {
        var _a;
        const index = slider.index;
        const perView = (_a = slider.settings.perView) !== null && _a !== void 0 ? _a : 1;
        const lastIndex = slides.length - perView;
        setArrowState(leftArrow, index === 0);
        setArrowState(rightArrow, index >= lastIndex);
    };
    const updateSlideFocusables = (slide, isActive) => {
        const focusables = slide.querySelectorAll("a, button, input, [tabindex]");
        focusables.forEach(el => {
            el.setAttribute("tabindex", isActive && isElementVisible(el) ? "0" : "-1");
        });
    };
    const updateFocusables = () => {
        var _a;
        const index = slider.index;
        const perView = (_a = slider.settings.perView) !== null && _a !== void 0 ? _a : 1;
        slides.forEach((slide, i) => {
            const isVisibleSlide = i >= index && i < index + perView;
            updateSlideFocusables(slide, isVisibleSlide);
        });
        updateArrowState();
    };
    const handleArrowKey = (arrow, direction) => (e) => {
        if (arrow.dataset.disabled === "true")
            return;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            slider.go(direction);
        }
    };
    const setupArrows = () => {
        if (leftArrow)
            leftArrow.addEventListener("keydown", handleArrowKey(leftArrow, "<"));
        if (rightArrow)
            rightArrow.addEventListener("keydown", handleArrowKey(rightArrow, ">"));
    };
    const setupAgreementsToggle = () => {
        document.querySelectorAll(selectors.hpNewsletterExpandBtn).forEach(button => {
            button.addEventListener("click", () => {
                const section = button.closest(selectors.hpNewsletterContentAgreements);
                if (section)
                    section.classList.toggle("expanded");
                updateFocusables();
            });
        });
    };
    setupArrows();
    setupAgreementsToggle();
    slider.on(["mount.after", "run.after"], updateFocusables);
    updateFocusables();
}
